import { useState, useEffect } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface ContestStatus {
  ended: boolean;
  endedAt?: Date;
  lastUpdated: Date;
}

export const useContestStatus = () => {
  const [status, setStatus] = useState<ContestStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const contestRef = doc(db, 'settings', 'contest-status');
    
    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(contestRef, (doc) => {
      if (doc.exists()) {
        setStatus({
          ended: doc.data().ended,
          endedAt: doc.data().endedAt?.toDate(),
          lastUpdated: doc.data().lastUpdated?.toDate()
        });
      } else {
        setStatus({
          ended: false,
          lastUpdated: new Date()
        });
      }
      setLoading(false);
    }, (error) => {
      console.error('Error fetching contest status:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { 
    isEnded: status?.ended ?? false,
    endedAt: status?.endedAt,
    lastUpdated: status?.lastUpdated,
    loading 
  };
};